<ng-content select="[left-menu]"></ng-content>
<div class="wrapper"
     [class.has-header]="hasHeader">
    <div class="container">
        <div class="width-wrapper"
             [class.full-width]="fullPageWidth"
             [class.page-width]="!fullPageWidth">
            <div class="header">
                <ng-content select="[header]"></ng-content>
            </div>
            <div class="content">
                <breadcrumb></breadcrumb>
                <ng-content></ng-content>
            </div>
        </div>
    </div>
    <ng-content select="[footer]"></ng-content>
</div>

<full-width-loader *ngIf="loading"></full-width-loader>
